

export default {
    userList : [],
    totalRecords: 0,
    totalFiltered: 0
}
